// Rolling telemetry traces, like an F1 data screen: steering input, raw phone
// roll, throttle/brake, speed, tyre slip and battery charge. Dev builds only.

export interface TelemetryChannel {
  label: string;
  color: string;
  /** Value range mapped to the plot height. */
  min: number;
  max: number;
}

export class Telemetry {
  private readonly canvas: HTMLCanvasElement;
  private readonly ctx: CanvasRenderingContext2D;
  private readonly data: Float32Array[];
  private head = 0;
  private readonly length: number;
  visible = true;

  constructor(
    container: HTMLElement,
    readonly channels: TelemetryChannel[],
    seconds = 8,
    readonly rate = 60,
  ) {
    this.length = seconds * rate;
    this.data = channels.map(() => new Float32Array(this.length));
    this.canvas = document.createElement('canvas');
    this.canvas.className = 'telemetry';
    this.canvas.width = 360;
    this.canvas.height = 150;
    container.appendChild(this.canvas);
    this.ctx = this.canvas.getContext('2d')!;
    this.canvas.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      this.visible = !this.visible;
      this.canvas.classList.toggle('dim', !this.visible);
    });
  }

  push(values: number[]): void {
    for (let c = 0; c < this.data.length; c++) this.data[c]![this.head] = values[c] ?? 0;
    this.head = (this.head + 1) % this.length;
  }

  draw(): void {
    if (!this.visible) return;
    const { ctx, canvas } = this;
    const w = canvas.width;
    const h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(0,0,0,0.55)';
    ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = 'rgba(255,255,255,0.15)';
    ctx.beginPath();
    ctx.moveTo(0, h / 2);
    ctx.lineTo(w, h / 2);
    ctx.stroke();
    ctx.lineWidth = 1.5;
    ctx.font = '10px system-ui, sans-serif';
    this.channels.forEach((ch, c) => {
      const d = this.data[c]!;
      ctx.strokeStyle = ch.color;
      ctx.beginPath();
      for (let i = 0; i < this.length; i++) {
        const v = d[(this.head + i) % this.length]!;
        const x = (i / (this.length - 1)) * w;
        const y = h - ((v - ch.min) / (ch.max - ch.min)) * (h - 14) - 2;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
      ctx.fillStyle = ch.color;
      ctx.fillText(ch.label, 4 + c * 52, 10);
    });
  }
}
